var _line, _line2, _line3, _path, _line4, _line5, _line6, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirdrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.61148,
    y1: 11.934,
    x2: 14.3581,
    y2: 20.9644,
    stroke: "#68F4C9",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.969697,
    y1: -0.969697,
    x2: 11.6736,
    y2: -0.969697,
    transform: "matrix(-0.536875 0.843661 0.843661 0.536875 23.7576 11.6365)",
    stroke: "#68F4C9",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.969697,
    y1: -0.969697,
    x2: 11.6736,
    y2: -0.969697,
    transform: "matrix(0 -1 -1 0 14.5455 23.3101)",
    stroke: "#68F4C9",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78789 11.6365C6.78762 1.29307 24.2424 1.293 24.2424 11.6365",
    stroke: "#0BC196",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6.78767,
    y1: 11.6365,
    x2: 24.2422,
    y2: 11.6365,
    stroke: "#0BC196",
    strokeWidth: 1.93939
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 20.5424,
    y1: 25.8549,
    x2: 20.5424,
    y2: 23.4837,
    stroke: "#0EF1BC",
    strokeWidth: 1.58077,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 10.4582,
    y1: 25.8549,
    x2: 10.4582,
    y2: 23.4837,
    stroke: "#0EF1BC",
    strokeWidth: 1.58077,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5427 22.6933C20.5427 23.1399 20.1983 23.7199 19.2516 24.2343C18.3355 24.7321 17.0159 25.0644 15.5149 25.0644C14.014 25.0644 12.6943 24.7321 11.7782 24.2343C10.8316 23.7199 10.4871 23.1399 10.4871 22.6933C10.4871 22.2466 10.8316 21.6666 11.7782 21.1522C12.6943 20.6544 14.014 20.3221 15.5149 20.3221C17.0159 20.3221 18.3355 20.6544 19.2516 21.1522C20.1983 21.6666 20.5427 22.2466 20.5427 22.6933Z",
    fill: "white",
    stroke: "#0BC196",
    strokeWidth: 1.58077
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.472 25.8547C12.0235 29.0163 19.7811 28.6211 20.5569 25.8547",
    stroke: "#0EF1BC",
    strokeWidth: 1.58077,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirdrop);
export default __webpack_public_path__ + "static/media/airdrop.4bd8454fbf2e52c71bb1d8115b99d66e.svg";
export { ForwardRef as ReactComponent };